import { domain } from './var'

const main = {
    getTicketSignature   : `${domain}/wechat/sidebar/ticket`, // GET 获取签名
    // getCustomerInfo      : `${domain}/crm/sidebar/getCustomerInfo`, // GET 获取客户详情
    getCustomerInfo      : `${domain}/sidebar/customer/detail`, // GET 获取客户详情
    getExternalUser      : `${domain}/crm/sidebar/getExternalUser`, // GET 获取客户微信详情
    getCustomerList      : `${domain}/crm/sidebar/getCustomerList`, // GET 获取客户列表
    userBindCustomer     : `${domain}/crm/sidebar/userBindCustomer`, // GET 绑定客户
    getCustomerChangeList: `${domain}/crm/sidebar/getCustomerChangeList`, // GET 客户跟单记录
    followOrder          : `${domain}/crm/sidebar/followOrder`, // GET 客户跟单
    privacyNumber        : `${domain}/crm/sidebar/privacyNumber`, // 工作手机
    getCallRecord        : `${domain}/crm/sidebar/record`, // 通话记录
    getRecordUrl         : `${domain}/crm/sidebar/recordUrl`, // 查看电话录音
    getVisitList         : `${domain}/crm/sidebar/visitList`, // 查看电话录音日志
    visitProgress        : `${domain}/crm/sidebar/visitProgress`, // 上传通话记录进度
    getAllLabelContent   : `${domain}/crm/sidebar/getAllLabelContent`, // 获取字典
    getTagList           : `${domain}/sidebar/tag/bindList`, // 获取标签
    getTagGroupList      : `${domain}/sidebar/tag/group/list`, // 获取标签组列表
    getCustomerTagList   : `${domain}/sidebar/tag/customer`, // 获取客户标签
    bindTag              : `${domain}/sidebar/tag/bind`, // 绑定标签
    userinfo             : `${domain}/userinfo`, // GET

    getUserInfo                   : `${domain}/slogin`, // GET
    getContractList               : `${domain}/crm/mp/getContractList`, // GET 合同列表
    getChangeRecords              : `${domain}/crm/mp/getChangeRecords`, // GET  变更记录
    getCustomerSelectMaterialList : `${domain}/crm/mp/getCustomerSelectMaterialList`, // GET  获取客户选材列表
    customerConfirmMaterial       : `${domain}/crm/mp/customerConfirmMaterial`, // POST 确认选材
    getSelectMaterialChangeRecords: `${domain}/crm/mp/getSelectMaterialChangeRecords`, // GET 选材记录
    getContractInfo               : `${domain}/crm/mp/getContractInfo`, // GET 合同详情
    bindAuthCode                  : `${domain}/crm/mp/bindAuthCode`, // POST 绑定授权码
    sendVerifyCode                : `${domain}/crm/mp/sendVerifyCode`, // POST 发送验证码
    bindCustomer                  : `${domain}/crm/mp/bindCustomer`, // POST 绑定手机号
    getReportProgressList         : `${domain}/crm/mp/getReportProgressList`

}
export default main
